module.exports = __webpack_public_path__ + "static/media/bg_top_up_option_1.c9882d00.png";